import { ReactComponent as Polkadot } from "../../../components/icons/polkadot.svg";
import { polkadotColor } from "./common";

const gen6 = {
  name: "Gen6",
  icon: <Polkadot />,
  identity: "gen6",
  sub: "gen6",
  value: "gen6",
  chain: "gen6",
  symbol: "GSX",
  decimals: 18,
  chainIcon: "originalGen6",
  ...polkadotColor,
  buttonColor: "#E6007A",
  logo: "logo-img-2",
  modules: {
    treasury: false,
    governance: false,
    identity: false,
    multisig: false,
    vestings: false,
    proxy: false,
  },
  nodes: [
    { name: "Gen6 explorer", url: "wss://api.explorer.gen6.app/rpc"},
    // { name: "Gen6 app", url: "wss://gen6.app/node"},
    // { name: "localhost", url: "ws://127.0.0.1:9944" },
  ],
  useOnChainBlockData: true,
};

export default gen6;
